/* eslint-disable class-methods-use-this */
import { toastNotification } from 'react/utils/utils';
import { actionCreators as integrationsActions } from 'react/api/actions/integrations';

class IntegrationLogsFeedbackService {
  constructor(tenantId, url) {
    this.tenantId = tenantId;
    this.url = url;
  }

  connect() {
    const finalUrl = `${this.url}/notification/${this.tenantId}?event-notifier-sse`;

    this.eventSource = new EventSource(finalUrl);

    this.initListeners();
  }

  closeConnection() {
    this.eventSource.close();
  }

  initListeners() {
    this.eventSource.onmessage = (eventMessage) => {
      if (!this.isEventMessageValid(eventMessage)) { return; }

      const frameData = JSON.parse(eventMessage.data);
      this.handleEventActions(frameData);
    };
  }

  isEventMessageValid(eventMessage) {
    if (eventMessage.type !== 'message') { return false; }

    const frameData = JSON.parse(eventMessage.data);

    if (!frameData.message || !frameData.action) { return false; }

    return true;
  }

  handleEventActions(frameData) {
    const { action, message } = frameData;

    const parsedMessage = JSON.parse(message);

    switch (action) {
      case 'SCHEDULED': {
        const integrationId = parsedMessage?.id;
        const integrationName = parsedMessage?.integration?.name;

        const toastData = {
          id: integrationId,
          customElementType: 'logs-feedback-scheduled',
          type: 'error',
          data: {
            title: 'Integration.scheduledToastFeedback.title',
            integrationId,
            integrationName
          }
        };

        window.globalStore.dispatch(integrationsActions.addIntegration(parsedMessage));
        toastNotification.addToast(toastData);

        break;
      }
      case 'RETRY': {
        if (!parsedMessage?.length) { return; }

        const configuration = parsedMessage[0]?.configuration;
        const pageId = `${configuration}-retriedLogs`;
        const totalRecords = parsedMessage?.length;
        const syncedRecords = parsedMessage
          .filter((record) => record.httpStatus === 200)
          .length;

        const toastData = {
          id: pageId,
          customElementType: 'logs-feedback',
          type: 'info',
          data: {
            title: 'Integration.retryToastFeedback.title',
            pageId,
            totalRecords,
            syncedRecords,
            records: parsedMessage,
            configuration
          }
        };

        toastNotification.addToast(toastData);

        break;
      }
      default:
        console.log('ChatEventStream send a message with unknown action', frameData);
    }
  }

  logError(err) {
    new Monet.Exception
      .ReturnError(this, (err?.message || 'Error'), err)
      .console();
  }
}

export default IntegrationLogsFeedbackService;
